import AuthorizationsList from 'components/Cards/components/CardsAuthorizations/components/AuthorizationsList';

const CardsAuthorizations = () => {
  return <AuthorizationsList />;
};

export default CardsAuthorizations;
